<template lang="html">
  <div class="input-border">
    <label for="promocodeTotalUseLimit"></label>
    <span class="text">Maximální počet použití</span>
    <div class="group">
      <div class="border-gr short">
        <input name="promocodeTotalUseLimit" type="text" autocomplete="nope"
               v-on:input="$emit('print-number-of-users', $event.target.value)"
               :value="numberOfUsers"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['print-number-of-users'],
  props: {
    numberOfUsers: {
      type: Number
    }
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
		toggleInput() {
			this.visible = !this.visible;
		},
    toggleInputOutside() {
      this.visible = false;
    },
	},
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';
@import "@/assets/styles/_promocode.scss";
</style>
